// The words the kit's own controls show (Batal, Cari…, Muat lebih banyak…), supplied by the app so the
// kit stays dictionary-agnostic (R1-09f): the app reads them from its dictionary in the active language.
import * as React from "react";

export interface KitText {
  /** Closes a dialog or confirmation without acting. */
  cancel: string;
  /** Screen-reader name of a dialog's or sheet's × button. */
  close: string;
  /** Retries a failed load. */
  retry: string;
  /** Search box placeholder ("Cari…"). */
  searchPlaceholder: string;
  /** Search box name for screen readers ("Cari"). */
  search: string;
  /** Combobox with nothing matching the search. */
  noMatch: string;
  /** Combobox entry that clears the filter. */
  all: string;
  /** Combobox options that couldn't be fetched. */
  optionsFailed: string;
  /** Data table states. */
  loadFailed: string;
  loadFailedHint: string;
  noResults: string;
  /** "Nothing matches “{query}”." */
  noResultsFor: (query: string) => string;
  empty: string;
  /** Name of a row's "⋯" menu and its column. */
  actions: string;
  loading: string;
  loadMore: string;
  nextPageFailed: string;
  /** Page mode's footer: its landmark name, the buttons and "Halaman {n}". */
  pagination: string;
  previousPage: string;
  nextPage: string;
  pageNumber: (page: number) => string;
  /** Date picker. */
  pickDate: string;
  clearDate: string;
  /** Data table sort picker in the card layout (no column headers there): its name and directions. */
  sortBy: string;
  sortAscending: string;
  sortDescending: string;
  /** Breadcrumb landmark and its "…" overflow. */
  breadcrumb: string;
  more: string;
}

const KitTextContext = React.createContext<KitText | null>(null);

export function KitTextProvider(props: { value: KitText; children: React.ReactNode }) {
  return <KitTextContext.Provider value={props.value}>{props.children}</KitTextContext.Provider>;
}

export function useKitText(): KitText {
  const text = React.useContext(KitTextContext);
  if (!text) throw new Error("Kit components need a <KitTextProvider> above them");
  return text;
}
